/** @format */

import React, { FC, useState, useEffect, createContext } from 'react'
import { useParams } from 'react-router'
import MonitorBreadCrumb from 'src/containers/MonitorCloud/MonitorCloudChart/MonitorBreadCrumb'
import MonitorChartList from 'src/containers/MonitorCloud/MonitorCloudChart/MonitorChartList'
import MonitorChartExport from 'src/containers/MonitorCloud/MonitorCloudChart/MonitorChartExport'
import { useToggle } from 'react-use'
import { RouteParams, IChartContextType, childTypeMap } from './constants'
import { request } from 'src/utils'
import useGlobalData from 'src/hooks/useGlobalData'
import API from 'src/api/ApiCloud'
import { cloneDeep } from 'lodash'

export const CountContext = createContext<IChartContextType>({})
// RDS代理实例、Cassandra、TiDB、分布式数据库 去除主实例
const childTypeMapProduct = ['119', '109', '96', '39']
const MonitorCloudChart: FC = () => {
  const {
    productType,
    instanceId: decInstanceId,
    topType = productType,
    instanceName: decInstanceName,
    regionName
  } = useParams<RouteParams>()
  const productMenu = useGlobalData('productMenu')
  const productList = useGlobalData('productList')
  const [contextState, setContextState] = useState<IChartContextType>({})
  const [exportVisible, setExportVisible] = useToggle(false)
  const [exportData, setExportData] = useState([])
  const [rangeDate, setRangeDate] = useState<[number, number]>([null, null])
  const [instanceName, setInstanceName] = useState<string>(decodeURIComponent(decInstanceName))
  const [instanceId, setInstanceId] = useState<string>(decodeURIComponent(decInstanceId))
  useEffect(() => {
    if (regionName) {
      localStorage.setItem('systemId', regionName)
    }
  }, [regionName])

  // 解析URL参数
  useEffect(() => {
    setInstanceName(decodeURIComponent(instanceName))
    setInstanceId(decodeURIComponent(decInstanceId))
  }, [decInstanceName, decInstanceId])
  useEffect(() => {
    if (productType && instanceId && topType && productList?.length) {
      // 查询菜单
      const curProduct = productMenu.find(menu => menu.productType === parseInt(productType))
      if (topType === productType && !childTypeMapProduct.includes(topType)) {
        // Redis
        if (childTypeMap[topType]) {
          const data = childTypeMap[topType]
          const { childType, childName } = data[0]
          const nameSpace = productList.find(
            menu => menu.productType === parseInt(childType)
          )?.namespace
          setContextState({
            curProduct,
            nameSpace,
            regionName,
            instanceId,
            instanceName,
            topType: parseInt(topType),
            childTypes: data,
            childTypeValue: { childType, childName },
            subInstanceList: [{ instanceId, instanceName }],
            currentInstance: { instanceId, instanceName },
            setChartContext
          })
        } else {
          // 单一类型
          const nameSpace = productList.find(
            menu => menu.productType === parseInt(productType)
          )?.namespace
          setContextState({
            curProduct,
            nameSpace,
            regionName,
            instanceId,
            instanceName,
            topType: null,
            currentInstance: { instanceId: undefined, instanceName: undefined },
            setChartContext
          })
        }
      } else {
        getChildTypes(topType, curProduct)
      }
    }
  }, [productType, instanceId, topType, productList])

  // 获取childTypes
  const getChildTypes = async (topType, curProduct) => {
    let childTypeList = []
    // Cassandra 请求节点实例 || TiDB 没有主实例
    if (childTypeMapProduct.includes(topType)) {
      childTypeList = cloneDeep(childTypeMap[topType])
    } else {
      const { data } = await request(API.getChildType, {
        data: {
          TopType: topType
        }
      })
      childTypeList = cloneDeep(data.childTypeList)
    }
    if (childTypeList?.length) {
      const { childType, childName } = childTypeList[0]
      const instanceObject = { instanceId: '', instanceName: '' }
      let subInstanceList = []
      const nameSpace = productList.find(
        menu => menu.productType === parseInt(childType)
      )?.namespace
      if (parseInt(childType) !== parseInt(topType) || topType === '120') {
        // childType = [68、51、53、109、119]的时候会触发
        const {
          data: { resourceList }
        } = await request(API.getChildInstance, {
          method: 'POST',
          data: {
            ProductType: parseInt(productType),
            ChildType: childType,
            ParentInstanceIds: [instanceId]
          }
        })
        if (resourceList?.length) {
          subInstanceList = resourceList
          const { instanceName, instanceId } = resourceList[0]
          instanceObject.instanceId = instanceId
          instanceObject.instanceName = instanceName
        }
      } else {
        instanceObject.instanceId = instanceId
        instanceObject.instanceName = instanceName
        subInstanceList.push({
          instanceId,
          instanceName
        })
      }
      setContextState({
        curProduct,
        nameSpace,
        regionName,
        instanceId,
        instanceName,
        topType: parseInt(topType),
        childTypes: childTypeList || [],
        childTypeValue: { childType, childName },
        subInstanceList,
        currentInstance: instanceObject,
        setChartContext
      })
    }
  }

  const setChartContext = value => {
    if (Object.keys(value).includes('childTypeValue')) {
      const nameSpace = productList.find(
        menu => menu.productType === parseInt(value?.childTypeValue?.childType)
      )?.namespace
      setContextState(state => {
        return {
          ...state,
          ...value,
          nameSpace
        }
      })
    } else {
      setContextState(state => {
        return {
          ...state,
          ...value
        }
      })
    }
  }

  // 打开导出弹窗
  const openExport = (exportData, rangeDate) => {
    setRangeDate(rangeDate)
    setExportData(exportData)
    setExportVisible(true)
  }

  // 关闭导出弹窗
  const closeExport = value => {
    if (!value) {
      setExportVisible(value)
      setExportData([])
    }
  }

  return (
    <CountContext.Provider value={contextState}>
      {/* 面包屑 */}
      <MonitorBreadCrumb />
      {/* 筛选 && 图表 */}
      <MonitorChartList openExport={openExport} />
      {/* 导出 */}
      <MonitorChartExport
        visible={exportVisible}
        rangeDate={rangeDate}
        exportData={exportData}
        closeExport={closeExport}
      />
    </CountContext.Provider>
  )
}

export default MonitorCloudChart
